export default "__VITE_ASSET__Bqvt_eTe__"